module.exports = __webpack_public_path__ + "img/12_39.20725bca.png";